import React, { useEffect } from "react";
import "./Sidebar.css";
import SidebarsContent from "./SidebarsContent";

import { AiOutlineClose } from "react-icons/ai";
import logodefault from "../../Assets/Logos/logov.png";
import axios from "axios";
const Sidebar = ({ isOpen, toggleSidebar, isSmallScreen }) => {
  const [logo, setLogo] = React.useState("");
  const checkSpecialagent = async () => {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/special-agent/check-special-agent-child`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );
    const responseData = response.data.agentData;
    if (responseData) {
      setLogo(responseData.logo);
    } else {
      setLogo(logodefault);
    }
  };
  useEffect(() => {
    checkSpecialagent();
  }, []);

  const isCollapsed = !isSmallScreen && !isOpen;

  return (
    <React.Fragment>
      <div
        className={`scroll-container overflow-y-auto left-0 bg-white shadow fixed inset-y-0 transition-all duration-300 ease-in-out ${
          isSmallScreen
            ? isOpen ? "translate-x-0 w-64 px-6" : "-translate-x-full w-64 px-6"
            : isOpen ? "translate-x-0 w-64 px-6" : "translate-x-0 w-20 px-3"
        } py-8`}
        style={{ zIndex: 50 }}
      >
        <div className={`flex ${isCollapsed ? "justify-center px-0" : "justify-between px-4"} items-center mb-5`}>
          <div className="flex items-center justify-center">
            <img
              src={logo ? logo : logodefault}
              alt="logo"
              className={`${isCollapsed ? "w-10 h-10 object-contain" : "w-15 h-15 object-contain"}`}
            />
          </div>
          {!isCollapsed && (
            <button
              onClick={toggleSidebar}
              className="text-gray-600 md:hidden hover:text-[#2E3A8C] transition duration-300"
            >
              <AiOutlineClose size={24} />
            </button>
          )}
        </div>

        <SidebarsContent isCollapsed={isCollapsed} />
      </div>
    </React.Fragment>
  );
};

export default Sidebar;
